import "@/store"

export const state = () => ({
  results: [],
  items_count: 0,
  pages_count: 0,
  loading: false
})

export const mutations = {
  setList: (state, payload) => (state.list = payload || []),

  setLoader(state, payload) {
    state.loading = !!payload
  },

  createItem(state, payload) {
    state.results = [
      ...state.results,
      {
        ...payload,
        title: JSON.parse(payload.title)
      }
    ]
  },
  updateItem(state, payload) {
    const findIndex = state.results.findIndex((item) => item.id == payload.id)
    if (findIndex !== -1) {
      state.results = [
        ...state.results.slice(0, findIndex),
        payload,
        ...state.results.slice(findIndex + 1)
      ]
    }
  },
  deleteItem(state, payload) {
    const findIndex = state.results.findIndex((item) => item.id == payload)
    if (findIndex != -1) {
      state.results = [
        ...state.results.slice(0, findIndex),
        ...state.results.slice(findIndex + 1)
      ]
    }
  },

  setProps(state, payload) {
    Object.keys(state).forEach((item) => {
      if (item in payload) {
        state[item] = payload[item]
      }
    })
  }
}

export const actions = {
  fetch({ commit }, params) {
    commit("setLoader", true)
    return this.$api
      .get("/newspaper/list", {
        params: params
      })
      .then((res) => {
        commit("setProps", {
          ...res.data,
          loading: false
        })
        return res.data || []
      })
      .catch((err) => {
        console.error(err)
        commit("setLoader")
        return []
      })
  },

  detail(_, slug) {
    return this.$api
      .get("/newspaper/get/" + slug)
      .then((res) => {
        return res.data || {}
      })
      .catch((err) => {
        console.error(err)
        return {}
      })
  },

  submit(_, newspaperItem) {
    // console.log('newspaperItem', newspaperItem);
    const f = new FormData()

    Object.keys(newspaperItem).forEach((item) =>
      f.append(item, newspaperItem[item])
    )

    const req = {
      method: newspaperItem.id ? "put" : "post",
      url: newspaperItem.id
        ? "/newspaper/update/" + newspaperItem.id
        : "/newspaper/create"
    }

    return this.$api[req.method](req.url, f)
      .then((res) => {
        return res.data || {}
      })
      .catch((err) => {
        console.error(err)
      })
  },

  deleteA({ commit }, newspaperId) {
    return this.$api
      .delete("/newspaper/delete/" + newspaperId)
      .then((res) => {
        commit("deleteItem", newspaperId)
        return res && res.status >= 200 && res.status <= 204
      })
      .catch((err) => {
        console.error(err)
        return false
      })
  }
}
